/* eslint no-console: 0 */

import Vue from 'vue/dist/vue.js'
import TechtalksFeed from '@components/techtalks_feed/TechtalksFeed'

Vue.component('techtalks-feed', TechtalksFeed)

new Vue({ el: document.getElementById('techtalks-feed') })
